import React, { Component, Fragment } from 'react';

import Content from './styles';
import { Row, Label, Input } from '../../../../../assets/styles';

class Stock extends Component {
  state = {
    sku: '',
    quantity: '',
    skuError: false,
    skuFocus: false,
    quantityError: false,
    quantityFocus: false,
  }

  componentDidMount = () => {
    const { currentMaterial } = this.props;

    if (currentMaterial) {
      this.setState({
        sku: currentMaterial.sku,
        quantity: currentMaterial.quantity,
      });
    }
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      sku,
      quantity,
      skuError,
      quantityError,
    } = this.state;

    if (!skuError && !quantityError) {
      return {
        sku,
        quantity: Number(quantity),
      };
    }

    return false;
  }

  validateInputs = () => {
    const { sku, quantity } = this.state;

    this.setState({
      skuError: false,
      quantityError: false,
    });

    if (sku.length === 0) this.setState({ skuError: true });
    const numberReg = /^[0-9]+$/;
    if (!numberReg.test(quantity)) this.setState({ quantityError: true });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      sku,
      quantity,
      skuError,
      skuFocus,
      quantityError,
      quantityFocus,
    } = this.state;

    return (
      <Fragment>
        {this.props.active && (
          <Content>
            <Row>
              <div className="row-2">
                <Label>
                  <p className="fieldName">Código (SKU)</p>
                  <Input
                    type="text"
                    name="sku"
                    value={sku}
                    error={skuError}
                    onFocusInput={skuFocus}
                    onChange={this.handleInputChange}
                    onFocus={() => this.onFocus('skuFocus')}
                    onBlur={() => this.onBlur('skuFocus')}
                  />
                </Label>
                <Label />
              </div>
              <div className="row-2">
                <Label>
                  <p className="fieldName">Quantidade</p>
                  <Input
                    type="number"
                    name="quantity"
                    value={quantity}
                    error={quantityError}
                    onFocusInput={quantityFocus}
                    onChange={this.handleInputChange}
                    onFocus={() => this.onFocus('quantityFocus')}
                    onBlur={() => this.onBlur('quantityFocus')}
                  />
                </Label>
                <Label />
              </div>
            </Row>
          </Content>
        )}
      </Fragment>
    );
  }
}

export default Stock;
